import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import { reduce, trim } from 'lodash';
import StageDisplay from '../opportunity-box/Stage';

class SellerAttributeModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opportunity: null,
      salesReps: null,
      reason: null,
      attribute: null,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.opportunity) {
      this.setState({ opportunity: nextProps.opportunity });
    }
    if (nextProps.salesReps) {
      this.setState({ salesReps: nextProps.salesReps });
    }
    if (nextProps.reason) {
      this.setState({ reason: nextProps.reason });
    }
    if (nextProps.attribute) {
      this.setState({ attribute: nextProps.attribute });
    }
  }

  close() {
    this.props.onClose();
  }

  onExited() {
    this.setState({
      opportunity: null, salesReps: null, reason: null, attribute: null,
    });
  }

  renderTitle() {
    const { reason, attribute } = this.state;
    if (!reason || !attribute) {
      return null;
    }
    const impactText = (reason.impact_text || '').replace('Impact', '').replace('impact', '');
    return (
      <span>{impactText} <span className="text-lowercase">{reason.classification_text}</span> in <span className="text-lowercase">{attribute.seller_label}</span></span>
    );
  }

  renderHeadline() {
    const { opportunity, attribute, salesReps } = this.state;
    if (!opportunity || !attribute) {
      return null;
    }
    const { stage } = opportunity;
    const outcome = (<StageDisplay isPast={false} value={stage} type="verb" />);
   
    let salesRepsComp = null;
    if (salesReps) {
      salesRepsComp = (
        <strong>{salesReps.first_name} {salesReps.last_name}</strong>
      );
      if (salesReps.sales_profile_url) {
        salesRepsComp = (
          <a href={salesReps.sales_profile_url}>{salesRepsComp}</a>
        );
      }
    }
    return (
      <span>{salesRepsComp} indicated <span className="text-lowercase">{attribute.seller_label}</span> helped us {outcome} because:</span>
    );
  }

  renderBody() {
    const { reason } = this.state;
    if (!reason) {
      return null;
    }
    const lines = reduce((reason.reason || '').split('\n'), (items, text, id) => {
      if (trim(text).length > 0) {
        items.push((
          <p key={id}>{text}</p>
        ));
      }
      return items;
    }, []);
    
    return (
      <div className="well">
        {lines}
      </div>
    );
  }

  render() {
    const open = this.props.opportunity && this.props.opportunity.opportunity_id !== undefined;
    return (
      <Modal
        show={open}
        onHide={this.close}
        onExited={this.onExited}
        bsSize="lg"
      >
        <div>
          <Modal.Header closeButton>
            <Modal.Title>{this.renderTitle()}</Modal.Title>
          </Modal.Header>
        </div>
        <Modal.Body>
          <div>
            <strong>{this.renderHeadline()}</strong>
          </div>
          <div>
            {this.renderBody()}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.close}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SellerAttributeModal.propTypes = {
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    stage: PropTypes.string,
  }),
  salesReps: PropTypes.shape({}),
  reason: PropTypes.shape({}),
  attribute: PropTypes.shape({}),
  onClose: PropTypes.func,
};
SellerAttributeModal.defaultProps = {
  opportunity: null,
  salesReps: null,
  reason: null,
  attribute: null,
  onClose: () => {},
};
export default SellerAttributeModal;